import template from './offer_modal.html';

angular.module('caferealtor.offer.list').component('offerModal', {
  transclude: true,
  bindings: {},
  controller: OfferModalController,
  controllerAs: 'vm',
  template,
});

OfferModalController.$inject = ['ModalService'];
function OfferModalController(ModalService) {
  const vm = this;
  vm.offerModal = ModalService.offerModal;

  vm.closeModal = () => {
    ModalService.closeOfferModal();
  };

  // Tab control
  // Valid tabs are 'preview' and 'log'
  vm.offerModal.tab = 'preview';
  vm.setTab = tab => {
    vm.offerModal.tab = tab;
  };
}
